// extracted by mini-css-extract-plugin
module.exports = {"tags":"QSRTags_tags__TMg1H","item":"QSRTags_item__9fDRn","v2":"QSRTags_v2__ji8o6"};